import type { ComponentProps } from "@blocknote/react";
import classNames from "classnames";
import { forwardRef } from "react";
import { bgStyles, borderStyles, flexStyles, paddingStyles, positionStyles, widthStyles } from "ui";

export const Content = forwardRef<HTMLDivElement, ComponentProps["Generic"]["Popover"]["Content"]>((props, ref) => {
  const { children, className } = props;
  return (
    <div
      ref={ref}
      className={classNames(
        positionStyles.absolute,
        positionStyles.right0,
        positionStyles.top275,
        bgStyles.neutral0,
        flexStyles.vert050,
        flexStyles.justifyStretch,
        borderStyles.neutral200,
        borderStyles.radius025,
        widthStyles.min2000,
        paddingStyles.p050,
        className,
      )}
    >
      {children}
    </div>
  );
});
